module.exports = __webpack_public_path__ + "img/user-avatar.50826cba.png";